// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__15vKV","footer":"ModalCreateQualiphyProcedure_footer__1EWvg","additionData":"ModalCreateQualiphyProcedure_additionData__2PVkE"};